<p>
  data-entity-editor-base works!
</p>
